import React from "react";
import Footer from "./Essentials/Footer";
import Navbar from "./Essentials/Navbar";
import { getDatabase, get, child, ref, set } from "@firebase/database";
import "./Css/Contact.css";
import { initializeApp } from "firebase/app";
import config from "./CONFIDENTIAL.js";
import { useLocation } from "react-router-dom";

function Contact() {
  const router = useLocation();

  const app = initializeApp(config);
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [message, setMessage] = React.useState("");
  function validate() {
    const isName = new RegExp("[a-zA-Z]+");
    const isEmail = new RegExp("[a-zA-Z_.]+@[a-z]+.[a-z]+");
    if (
      name.length != 0 &&
      isName.test(name) &&
      email.length != 0 &&
      isEmail.test(email) &&
      message.length != 0
    ) {
      const db = getDatabase();
      get(child(ref(getDatabase()), `/Users`)).then(dataLength => {
        set(ref(db, `/Users/${dataLength.val().length}`), {
          name: name,
          email: email,
          number: "0000",
          message: message,
          postedOn:
            new Date().getDate() +
            "/" +
            (parseInt(new Date().getMonth()) + 1) +
            "/" +
            new Date().getFullYear()
        })
          .then(e => {
            alert("Submitted your details");
            setName("");
            setEmail("");
            setMessage("");
            for (var i = 0; i < 3; i++)
              document.querySelectorAll(".data-field")[i].value = "";
          })
          .catch(e => alert("Oops!! please try again later.."));
      });
    } else {
      alert("Enter valid data");
    }
  }
  return (
    <div>
      <Navbar />
      <center>
        <br />
        <div className="touch-card">
          <p
            style={{
              color: "#024369",
              fontSize: "1.3rem",
              borderBottom: "3px solid lightblue",
              width: "max-content"
            }}
          >
            Get in touch with us
          </p>
          <input
            className="data-field"
            onChange={e => setName(e.target.value)}
            placeholder="Name/ नाम*"
          />
          <input
            className="data-field"
            onChange={e => setEmail(e.target.value)}
            placeholder="Email Address/ईमेल पता*"
          />
          <textarea
            className="data-field"
            onChange={e => setMessage(e.target.value)}
            placeholder="Message  / संदेश*"
          />
          <button onClick={validate}>Submit</button>
        </div>
      </center>
      <Footer />
    </div>
  );
}

export default Contact;
